.headerTitle {
  font-weight: 600;
}

.headerLink {
  cursor: pointer;
  color: #3d42bc;
}
.headerLink a,
.headerLink button {
  color: #3d42bc;
}

.itemTitle {
  font-weight: 500;
  margin: 0 0 0.2rem 1rem;
}

.itemSubTitle {
  margin: 0 0 0.2rem 1rem;
  word-wrap: break-word;
  white-space: normal;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL0dsb2JhbFNlYXJjaCIsInNvdXJjZXMiOlsiY2xhc3Nlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7QUFBQTtFQUVFOzs7QUFJSjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmhlYWRlclRpdGxlIHtcbiAgZm9udC13ZWlnaHQ6IDYwMDtcbn1cblxuLmhlYWRlckxpbmsge1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIGNvbG9yOiAjM2Q0MmJjO1xuXG4gIGEsXG4gIGJ1dHRvbiB7XG4gICAgY29sb3I6ICMzZDQyYmM7XG4gIH1cbn1cblxuLml0ZW1UaXRsZSB7XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIG1hcmdpbjogMCAwIDAuMnJlbSAxcmVtO1xufVxuXG4uaXRlbVN1YlRpdGxlIHtcbiAgbWFyZ2luOiAwIDAgMC4ycmVtIDFyZW07XG4gIHdvcmQtd3JhcDogYnJlYWstd29yZDtcbiAgd2hpdGUtc3BhY2U6IG5vcm1hbDtcbn1cbiJdfQ== */